module.exports = __webpack_public_path__ + "static/investing-community-desktop.3f2a3e73.webp";